export default __webpack_public_path__ + "static/media/filters.8e9825e0.svg";